<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="3" class="search-col in-codes">
      <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Поиск"
              single-line
              hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="12">
      <v-data-table
              no-data-text="Нет промокодов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="promocodes"
              v-model="selected"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :search="search"
              :options.sync="options"
              :footer-props="footerProps"
              :server-items-length="total"
              :items-per-page="15"
              :loading="loading"
              loading-text="Загрузка промокодов... Подождите пожалуйста"
      >
        <template v-slot:item.promocode.is_multiple="{ item }">
          <template v-if="item.is_multiple">
            Многороразовый
          </template>
          <template v-else>
            Одноразовый
          </template>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import PromocodeService from '../../api/PromocodeService'

    export default {
        name: 'ProductIndex',
        components: {},
        data: () => ({
            overlay: false,
            search: '',
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            selected: [],
            promocodes: [],
            branches: [],
            options: {},
            promocode: {
                id: null,
                name: '',
                name_ua: '',
            },
            footerProps: {
                itemsPerPageText: 'Промокодов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
              itemsPerPageOptions: [15, 30]
            },
            total: 0,
            headers: [
                {
                    text: 'Код',
                    value: 'code',
                    sortable: false
                },
                {
                    text: 'Название',
                    value: 'promocode.name',
                },
                {
                    text: 'Дата генерации',
                    value: 'created_at',
                },
                {
                  text: 'Срок действия',
                  value: 'promocode.date_to',
                },
                {
                  text: 'Активирован',
                  value: 'activated_at',
                },
                {
                  text: 'Тип',
                  value: 'promocode.is_multiple',
                  sortable: false,
                },
                {
                  text: 'Кол-во использований',
                  value: 'count_use',
                },
                {
                  text: 'Пользователь',
                  value: 'user.name',
                },
                {
                  text: 'Телефон',
                  value: 'user.phone',
                  sortable: false,
                },
            ],
        }),
        mounted() {
        },
        watch: {
            search() {
              this.getDataFromApi()
            },
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
            removePromocode(item){
              PromocodeService.remove(item.id).then(response => {
                  this.loading = true
                  this.getDataFromApi()
              })
            },
            getDataFromApi() {
                this.loading = true
              this.selected = [];
                let params = {
                  page: this.options.page,
                  perPage: this.options.itemsPerPage,
                  sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
                  sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
                  search: this.search,
                }

                PromocodeService.listCodes(params)
                    .then(response => {
                        this.promocodes = response.data.data
                        this.total = response.data.total
                        this.loading = false
                    })
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
